/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const mobile = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      fill="#000"
      d="M5.25.75V0v.75Zm0 15v.75-.75Zm5.5 0v.75-.75Zm2-2h.75-.75Zm0-11h.75-.75Zm-2-2.75h-5.5v1.5h5.5V0Zm-5.5 0c-.73 0-1.429.29-1.945.805l1.061 1.061A1.25 1.25 0 0 1 5.25 1.5V0ZM3.305.805A2.75 2.75 0 0 0 2.5 2.75H4c0-.332.132-.65.366-.884L3.306.806ZM2.5 2.75v11H4v-11H2.5Zm0 11c0 .73.29 1.429.805 1.944l1.061-1.06A1.25 1.25 0 0 1 4 13.75H2.5Zm.805 1.944a2.75 2.75 0 0 0 1.945.806V15a1.25 1.25 0 0 1-.884-.366l-1.06 1.06Zm1.945.806h5.5V15h-5.5v1.5Zm5.5 0c.73 0 1.429-.29 1.944-.806l-1.06-1.06a1.25 1.25 0 0 1-.884.366v1.5Zm1.944-.806a2.75 2.75 0 0 0 .806-1.944H12c0 .332-.132.65-.366.884l1.06 1.06Zm.806-1.944v-11H12v11h1.5Zm0-11c0-.73-.29-1.429-.806-1.945l-1.06 1.061c.234.235.366.552.366.884h1.5ZM12.694.805A2.75 2.75 0 0 0 10.75 0v1.5c.332 0 .65.132.884.366l1.06-1.06ZM8 4v1.5A1.5 1.5 0 0 0 9.5 4H8Zm0 0H6.5A1.5 1.5 0 0 0 8 5.5V4Zm0 0V2.5A1.5 1.5 0 0 0 6.5 4H8Zm0 0h1.5A1.5 1.5 0 0 0 8 2.5V4Z"
    />
  </svg>
)
export default mobile
